import { useState } from "react"
import Select, { components } from "react-select"
import CreatableSelect from "react-select/creatable"

// import { ReactComponent as YourSvg } from "../caret-down-solid.svg"
import { ReactComponent as YourSvg } from "../select-picto.svg"

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <YourSvg style={{ width: 12, color: "#007d8f" }} />
        </components.DropdownIndicator>
    )
}

function SearchFilters({ applyFilter, typeContrat, metier, localisation }) {
    const [filters, setFilters] = useState({})
    const [inputValue, setinputValue] = useState("")
    const [value, setvalue] = useState([])

    function change(type, e) {
        filters[type] = e
        setFilters(filters)
        applyFilter(filters)
    }

    function createOption(label) {
        return {
            label,
            value: label,
        }
    }

    function handleChange(newValue, actionMeta) {
        // console.group("Value Changed")
        // console.log(newValue)
        // console.log(`action: ${actionMeta.action}`)
        // console.groupEnd()
        setvalue(newValue)
        change("text", newValue)
    }
    function handleInputChange(newInputValue) {
        setinputValue(newInputValue)
    }
    function handleKeyDown(event) {
        if (!inputValue) return
        switch (event.key) {
            case "Enter":
            case "Tab":
                let listvalue = [...value, createOption(inputValue)]
                setvalue(listvalue)
                change("text", listvalue)
                setinputValue("")
                event.preventDefault()
        }
    }

    return (
        <div className="job-search-filters">
            <CreatableSelect
                components={{ DropdownIndicator: null }}
                inputValue={inputValue}
                isClearable
                isMulti
                menuIsOpen={false}
                onChange={handleChange}
                onInputChange={handleInputChange}
                onKeyDown={handleKeyDown}
                placeholder={"Ajouter un mot-clé"}
                name="colors"
                className="job-search-filter"
                classNamePrefix="select"
                options={[]}
                value={value}
                noOptionsMessage={() => ""}
            />
            <Select
                isMulti
                name="colors"
                className="job-search-filter"
                classNamePrefix="select"
                placeholder={"Type de contrat"}
                options={typeContrat}
                onChange={(e) => change("contract_type_abbreviation", e)}
                components={{ DropdownIndicator: DropdownIndicator }}
            />
            <Select isClearable name="colors" className="job-search-filter" classNamePrefix="select" placeholder={"Métier"} options={metier} onChange={(e) => change("type_de_poste", e)} components={{ DropdownIndicator: DropdownIndicator }} />
            <Select isMulti name="colors" className="job-search-filter" classNamePrefix="select" placeholder={"Localisation"} options={localisation} onChange={(e) => change("localisation", e)} components={{ DropdownIndicator: DropdownIndicator }} />
        </div>
    )
}

export default SearchFilters
